import WeekDropdown from "./week-dropdown";

const modul = angular
    .module("BasketFixedComponents", [
        // SearchComponents,
    ])

    .directive("weekDropdown", WeekDropdown);

export default modul.name;
